import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const AuthChecker = ({ allowedRoles }) => {
    const { auth } = useAuth();
    const location = useLocation();

    return (
        allowedRoles?.includes(Number(auth?.role)) ?
            <Outlet /> : 
            auth?.username ?
                <Navigate to='/unauthorized' state = {{ from: location }} replace /> :
                <Navigate to='/login' state = {{ from: location }} replace />
    );
    
}

export default AuthChecker;

